import plugin from 'tailwindcss/plugin'
import fs from 'node:fs'
import path from 'node:path'

export default plugin(function ({ matchUtilities }) {
  const iconsDir = path.join(import.meta.dirname, '../../../assets/vendor/phosphoricons')
  const values = {}

  const variants = [
    ['', 'regular'],
    ['', 'light'],
    ['', 'bold'],
    ['', 'thin'],
    ['', 'duotone'],
    ['', 'fill'],
  ]

  variants.forEach(([suffix, dir]) => {
    fs.readdirSync(path.join(iconsDir, dir)).forEach((file) => {
      let name = path.basename(file, '.svg') + suffix
      values[name] = { name, fullPath: path.join(iconsDir, dir, file) }
    })
  })

  matchUtilities(
    {
      phosphor: ({ name, fullPath }) => {
        let content = fs
          .readFileSync(fullPath)
          .toString()
          .replace(/\r?\n|\r/g, '')
        return {
          [`--phosphor-${name}`]: `url('data:image/svg+xml;utf8,${content}')`,
          '-webkit-mask': `var(--phosphor-${name})`,
          mask: `var(--phosphor-${name})`,
          'mask-repeat': 'no-repeat',
          'mask-position': 'center',
          'background-color': 'currentColor',
          'vertical-align': 'middle',
          display: 'inline-block',
          width: '1.25rem',
          height: '1.25rem',
        }
      },
      'bg-phosphor': ({ fullPath }) => {
        let content = fs
          .readFileSync(fullPath)
          .toString()
          .replace(/\r?\n|\r/g, '')
        return {
          'background-image': `url('data:image/svg+xml;utf8,${content}')`,
        }
      },
    },
    { values },
  )
})
